/* eslint-disable no-unused-vars */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import Acl from 'vue-browser-acl'
import App from './App'
import router from '@/router'
import axios from 'axios'
import lodash from 'lodash'
import moment from 'moment'
import VeeValidate from 'vee-validate'
import UUID from 'vue-uuid'
import VueSignaturePad from 'vue-signature-pad'

import filters from '@/filters'
import dfsConfig from '@/config/config'
import dfsUserAPI from '@/api/user'
import store from '@/store'
import AclRules from '@/config/acl'

import 'vuetify/dist/vuetify.min.css'
import 'vue-simple-calendar/dist/static/css/default.css'

Vue.use(Vuetify)
Vue.use(UUID)
Vue.use(VeeValidate, { errorBagName: 'vErrors' })
Vue.use(Acl, store, AclRules, { router })
Vue.use(VueSignaturePad)

Vue.config.productionTip = false

Vue.prototype.$axios = axios
Vue.prototype._ = lodash
Vue.prototype.moment = moment
Vue.prototype.$dfsUserAPI = dfsUserAPI
Vue.prototype.$dfsConfig = dfsConfig
Vue.prototype.$bus = new Vue()

axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'

store.dispatch('setAxios', axios)
store.dispatch('setConfig', dfsConfig)

let oauthToken = localStorage.getItem('oauthToken')

if (oauthToken) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + oauthToken
}

store.state.axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    store.dispatch('logOut').then(() => {
      localStorage.clear()

      router.push({
        name: 'Login'
      })
    })
  }
})

if ((store.getters.currentUserRoles.length > 0 && store.getters.logInStatus === true) || !store.getters.logInStatus) {
  store.dispatch('setAppIsLoaded', true)
}

/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

window.vm = vm



// WEBPACK FOOTER //
// ./src/main.js